import { ServiceData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const servicesApi = apiResource<ServiceData>('services');
